export const INIT_FILTERS = 'GalleryPB/*InitFilters';
export const UPDATE_ACTIVE_FILTERS = 'GalleryPB/*/UpdateActiveFilters';
export const RESET_FILTERS = 'GalleryPB/*/ResetFilters';

export const SET_PREVIOUS_CURRENT_PAGE = 'GalleryPB/*/setPreviousCurrentPage';
